<template>
  <div class="bodycontent">
    <div class="page_title">
      优惠券过期提醒设置
    </div>
    <div class="page_form">
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="是否开启">
          <el-radio-group v-model="form.open">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label=" 剩余几天内提醒">
          <el-input
            size="small"
            v-model="form.start_day"
            class="inputWidth"
          ></el-input>
          至
          <el-input
            size="small"
            v-model="form.end_day"
            class="inputWidth"
          ></el-input>
          天
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确认</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { discountPastConfig, discountPastDetail } from "@/api/set";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      form: {
        open: "",
        start_day: "",
        end_day: ""
      }
    };
  },
  created() {
    this.get_detail();
  },
  methods: {
    async onSubmit(obj) {
      try {
        var data = {
          app_id: this.app_id,
          ...this.form
        };
        const res = await discountPastConfig(data);
        this.$message(res.msg);
      } catch (error) {
        console.log(error);
      }
    },
    async get_detail() {
      try {
        var data = { app_id: this.app_id };
        const res = await discountPastDetail(data);
        if (res.code == 200) {
          this.form.open = String(res.data.open);
          this.form.start_day = res.data.start_day;
          this.form.end_day = res.data.end_day;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form {
    margin-top: 20px;
  }
  .inputWidth {
    width: 60px;
  }
}
</style>
